export default __webpack_public_path__ + "static/media/hailoffuriousstrikes6.47f818ca.png";